import { useLang } from "../context/LangContext";
import { useSiteConfig } from "../context/ConfigContext";
import { BrandS } from "./Brand";

export const PlayBadge = ({ href, tid }) => {
  const inner = (
    <span className="flex items-center gap-2.5 rounded-xl bg-slate-900 px-4 py-2.5 text-left shadow-md transition hover:bg-slate-800 active:scale-[0.97]">
      <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0" aria-hidden="true">
        <path fill="#34D399" d="M3.6 2.3 13.8 12 3.6 21.7c-.4-.3-.6-.9-.6-1.6V3.9c0-.7.2-1.3.6-1.6Z" />
        <path fill="#FBBF24" d="m17.2 8.6-3.4 3.4L4.5 2.7l.5-.3c.6-.3 1.3-.2 1.9.2l10.3 6Z" />
        <path fill="#F87171" d="m17.2 15.4-10.3 6c-.6.4-1.3.5-1.9.2l-.5-.3 9.3-9.3 3.4 3.4Z" />
        <path fill="#60A5FA" d="m20.7 10.3-2.6 1.5-3-3.2 3-3.2 2.6 1.5c1.5.9 1.5 2.5 0 3.4Z" />
      </svg>
      <span>
        <span className="block text-[9px] font-medium uppercase tracking-wide text-slate-300">Get it on</span>
        <span className="block text-sm font-bold leading-tight text-white">Google Play</span>
      </span>
    </span>
  );
  if (!href) return <span data-testid={tid} className="inline-block opacity-90">{inner}</span>;
  return (
    <a data-testid={tid} href={href} target="_blank" rel="noreferrer" className="inline-block">
      {inner}
    </a>
  );
};

export const AppleBadge = ({ href, tid }) => {
  const inner = (
    <span className="flex items-center gap-2.5 rounded-xl bg-slate-900 px-4 py-2.5 text-left shadow-md transition hover:bg-slate-800 active:scale-[0.97]">
      <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 fill-white" aria-hidden="true">
        <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08ZM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25Z" />
      </svg>
      <span>
        <span className="block text-[9px] font-medium uppercase tracking-wide text-slate-300">Download on the</span>
        <span className="block text-sm font-bold leading-tight text-white">App Store</span>
      </span>
    </span>
  );
  if (!href) return <span data-testid={tid} className="inline-block">{inner}</span>;
  return (
    <a data-testid={tid} href={href} target="_blank" rel="noreferrer" className="inline-block">
      {inner}
    </a>
  );
};

export default function DownloadApp({ compact = false }) {
  const { t } = useLang();
  const { app_links } = useSiteConfig();

  return (
    <div
      data-testid="download-app-section"
      className={`flex items-center gap-4 rounded-3xl bg-gradient-to-br from-teal-700 to-teal-900 text-white ${
        compact ? "p-4" : "p-6 sm:p-8"
      }`}
    >
      <span className={`shrink-0 rounded-2xl bg-white/10 p-2.5 backdrop-blur ${compact ? "h-12 w-12" : "h-16 w-16"}`}>
        <BrandS />
      </span>
      <div className="min-w-0 flex-1">
        <p className={`font-heading font-extrabold tracking-tight ${compact ? "text-base" : "text-xl sm:text-2xl"}`}>
          {t("dl_t")}
        </p>
        <p className={`mt-0.5 text-teal-100 ${compact ? "text-[11px]" : "text-xs sm:text-sm"}`}>{t("dl_sub")}</p>
        <div className={`mt-3 flex flex-wrap items-center gap-2.5 ${compact ? "[&_span.text-sm]:text-xs [&_span]:py-1.5" : ""}`}>
          <AppleBadge tid="dl-app-store" href={app_links?.ios} />
          <PlayBadge tid="dl-google-play" href={app_links?.android} />
        </div>
      </div>
    </div>
  );
}
